function normalizeText(value = "") {
  return String(value || "").replace(/\s+/g, " ").trim();
}

function summaryLifecycleStatus(summary = {}) {
  return normalizeText(
    summary?.previousGenerationStatus ||
    summary?.generationStatus ||
    summary?.status
  ).toLowerCase();
}

function summaryIdentity(summary = {}) {
  if (!summary || typeof summary !== "object") return "";
  const fingerprint = normalizeText(summary.sourceTranscriptFingerprint);
  if (fingerprint) {
    return [
      `fingerprint:${fingerprint}`,
      normalizeText(summary.sourceFollowUpFingerprint),
      normalizeText(summary.summaryText),
      summaryLifecycleStatus(summary),
      normalizeText(summary.source),
      normalizeText(summary.reviewedAt),
    ].join("|");
  }
  return [
    normalizeText(summary.summaryText),
    normalizeText(summary.generatedAt || summary.createdAt),
    summaryLifecycleStatus(summary),
    normalizeText(summary.source),
    normalizeText(summary.reviewedAt),
  ].join("|");
}

function isHistoricalSummaryCandidate(summary = {}) {
  if (!summary || typeof summary !== "object") return false;
  if (!normalizeText(summary.summaryText)) return false;
  if (summary.fallbackUsed) return false;
  return !/\b(fallback|placeholder|active-session-placeholder)\b/i.test(
    normalizeText(summary.source)
  );
}

export function retainSupersededSummaryHistory(record = {}, previousRecord = null) {
  const previous = previousRecord && typeof previousRecord === "object" ? previousRecord : {};
  const previousSummary = previous.sessionSummary;
  const nextSummary = record?.sessionSummary;
  const existingHistory = [
    ...(Array.isArray(record?.summaryHistory) ? record.summaryHistory : []),
    ...(Array.isArray(previous?.summaryHistory) ? previous.summaryHistory : []),
  ];

  if (
    isHistoricalSummaryCandidate(previousSummary) &&
    summaryIdentity(previousSummary) !== summaryIdentity(nextSummary)
  ) {
    existingHistory.unshift({
      ...previousSummary,
      previousGenerationStatus: summaryLifecycleStatus(previousSummary),
      generationStatus: "superseded",
      status: previousSummary.status === "reviewed" ? "reviewed" : "superseded",
      isCurrent: false,
      supersededAt: new Date().toISOString(),
      supersededReason: "newer_transcript_or_summary_version",
    });
  }

  const seen = new Set();
  const summaryHistory = existingHistory
    .filter((summary) => summary && typeof summary === "object" && normalizeText(summary.summaryText))
    .filter((summary) => {
      const key = summaryIdentity(summary);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });

  return {
    ...record,
    summaryHistory,
  };
}
